



















import { Component, Vue, Prop, State, Watch } from 'nuxt-property-decorator';
import { Metadata, RootPage } from '@/types/pageContract';
import { Settings } from '@/types/initialData';

@Component({})
export default class Copyright extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.site?.settings)
  settings!: Settings;

  @State((state) => state.typo3?.initial?.site?.metadata)
  metadata!: Metadata;

  // @ts-ignore
  @State((state) => state.typo3?.page)
  rootPage!: RootPage;

  @Prop({ type: String, required: true })
  isbn!: string;

  @Prop({ type: String, required: true })
  publisher!: string;

  get copyrightYear(): string {
    if (this.metadata.copyright_year !== '') {
      return this.metadata.copyright_year;
    }
    return new Date().getFullYear().toString();
  }

  isSearchPage: boolean = false;

  @Watch('$route', { immediate: true })
  onRootPageChanged(): void {
    const rootPageIsEmpty = Object.keys(this.rootPage).length === 0;
    if (!rootPageIsEmpty) {
      this.isSearchPage =
        this.rootPage!.page!.id === this.settings!.searchPageId;
    } else {
      this.isSearchPage = false;
    }
  }
}
